import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const STRUCTURED_RATING_SCHEMA = Object.freeze({
  COMMUNICATION_RATING: 0,
  PUNCTUALITY_RATING: 0,
  PROFESSIONALISM_RATING: 0,
  QUALITY_RATING: 0,
  VALUE_RATING: 0,
});
export const RECORD = generateSchema(STRUCTURED_RATING_SCHEMA);
export const KEYS: any = generateKeys(STRUCTURED_RATING_SCHEMA);

export class StructuredRating extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);
  }

  get communicationRating(): number {
    return this.get(KEYS.COMMUNICATION_RATING);
  }

  get punctualityRating(): number {
    return this.get(KEYS.PUNCTUALITY_RATING);
  }

  get professionalismRating(): number {
    return this.get(KEYS.PROFESSIONALISM_RATING);
  }

  get qualityRating(): number {
    return this.get(KEYS.QUALITY_RATING);
  }

  get valueRating(): number {
    return this.get(KEYS.VALUE_RATING);
  }
}
